import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.errorNotify || initialState;

export const selectErrorNotifyShow = createSelector(
  [selectSlice],
  state => state.data.show,
);
